import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'

import { useMessage } from '@pepper/ui'
import { getIntegrationsList } from '@pepper/utils/src/api/integrations/integrations'

type ReturnType = {
  data: IIntegrationProps | undefined
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: Error | null
}

const DEFAULT_PAGE_SIZE = 100
export const useProfileIntegrationsList = ({
  companyId,
  currentPage = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  enabled = true
}: {
  companyId: string
  currentPage?: number
  pageSize?: number
  enabled?: boolean
}): ReturnType => {
  const { showError } = useMessage()

  const handleApiRequest = async () => {
    const response = await getIntegrationsList({
      companyId,
      pageSize,
      currentPage
    })
    if (response.status === 'error') {
      throw new Error(response.error)
    }
    return response?.data
  }

  const { isLoading, isFetching, isError, error, refetch, data } = useQuery<
    IIntegrationProps,
    Error
  >({
    queryKey: ['profile-integrations', companyId, pageSize, currentPage],
    queryFn: handleApiRequest,
    enabled,
    retry: 3
  })

  useEffect(() => {
    if (isError) {
      showError(error?.message)
    }
  }, [isError, error, showError])

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    error
  }
}
